<script lang="ts">
  import { router } from '$lib/router';
  import UnitInspector from './inspector/UnitInspector.svelte';
  import ZoneInspector from './inspector/ZoneInspector.svelte';
  import RoomInspector from './inspector/RoomInspector.svelte';
  import LoadInspector from './inspector/LoadInspector.svelte';
  import RcuInspector from './inspector/RcuInspector.svelte';
  import DinInspector from './inspector/DinInspector.svelte';
  import KeypadInspector from './inspector/KeypadInspector.svelte';
  import SceneInspector from './inspector/SceneInspector.svelte';

  let entity = $derived(router.selectedEntity);
  // Identifies which record is being inspected, not just which entity type.
  // Without this, switching between two records of the same type (or two
  // units, which don't even carry an `id` prop here) reuses the same
  // Inspector/InspectorField component instances — their local autosave
  // state (e.g. InspectorField's `dirty`/`localValue`) then belongs to the
  // *previous* record and can get saved onto the newly selected one. Keying
  // on the record identity forces a remount on every record change so each
  // record always starts with fresh, correctly-scoped local state.
  let inspectorKey = $derived(`${entity.type ?? 'unit'}:${entity.id ?? router.unitId ?? ''}`);
</script>

{#key inspectorKey}
  {#if !entity.type || entity.type === 'browse-loads' || entity.type === 'led-logic' || entity.type === 'products'}
    <UnitInspector />
  {:else if entity.type === 'zone'}
    <ZoneInspector id={entity.id!} />
  {:else if entity.type === 'room'}
    <RoomInspector id={entity.id!} />
  {:else if entity.type === 'load'}
    <LoadInspector id={entity.id!} />
  {:else if entity.type === 'rcu'}
    <RcuInspector id={entity.id!} />
  {:else if entity.type === 'din'}
    <DinInspector id={entity.id!} />
  {:else if entity.type === 'keypad'}
    <KeypadInspector id={entity.id!} />
  {:else if entity.type === 'scene'}
    <SceneInspector id={entity.id!} />
  {:else}
    <div class="px-3 py-3 text-sm text-text-muted">
      No inspector for {entity.type}
    </div>
  {/if}
{/key}
